module.exports = __webpack_public_path__ + "static/img/img3.9c8bb9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img3.jpg
// module id = DjEO
// module chunks = 101